import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b297645"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body d-flex justify-content-center align-items-center p-5" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = {
  key: 0,
  class: "ms-5"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ms-1 fa-solid fa-trash" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "ms-5"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ms-1 fa-solid fa-download" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ms-1 fa-solid fa-download" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('card card-bordered card-rounded bg-light-white ' + _ctx.className)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("i", {
            class: _normalizeClass(["fs-1 me-3 fa-solid", _ctx.mimeIcon]),
            style: {"color":"var(--kt-info)"}
          }, null, 2),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.attachment.translateKey ? _ctx.$t(_ctx.attachment.translateKey) : _ctx.attachment.name), 1),
            (_ctx.attachment.size)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, "(" + _toDisplayString(_ctx.sizeToHumanOctet) + ")", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.canDelete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteAttachment && _ctx.deleteAttachment(...args))),
                  class: "btn btn-sm btn-danger"
                }, _hoisted_9)
              ]))
            : _createCommentVNode("", true),
          (_ctx.attachment.attachmentUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.publicFile)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      target: "_blank",
                      href: _ctx.attachment.attachmentUrl,
                      class: "btn btn-sm btn-primary btn-violet"
                    }, _hoisted_13, 8, _hoisted_11))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
                      class: "btn btn-sm btn-primary btn-violet"
                    }, _hoisted_15))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}